import React, {useEffect, useState} from "react";
import {useParams, useNavigate} from "react-router-dom";
import ApiInterface from "@/commons/api/ApiInterface";
import Header from "@/commons/pages/borders/header/Header";
import Footer from "@/commons/pages/borders/footer/Footer";
import Calendar from "react-calendar";
import 'react-calendar/dist/Calendar.css';
import "./chats.css";
import CustomButton from "@/commons/components/buttons/customButton/CustomButton";

const Chats = () => {
    let {type} = useParams();
    const navigate = useNavigate();
    const basePath = "server/minecraft/chat/logs/" + type;
    const [files, setFiles] = useState([]);
    const [minDate, setMinDate] = useState(null);
    const maxDate = new Date(); // oggi

    useEffect(() => {
        const fetchFiles = async () => {
            try {
                // Ottiene tutti gli UUID dei file
                const filesResult = await ApiInterface.getFilesUUIDS(basePath);

                // Carica tutte le informazioni dei file
                const filesInfoPromises = filesResult.map(async (uuid) => {
                    try {
                        const fileInfo = await ApiInterface.getFileInfo(uuid);
                        return fileInfo;
                    } catch (err) {
                        console.error("Errore caricando file:", err);
                        return null; // Ritorna null in caso di errore per evitare interruzioni
                    }
                });

                // Aspetta che tutte le promesse siano completate
                const filesInfo = (await Promise.all(filesInfoPromises)).filter(file => file !== null);

                // Ordina i file e aggiorna lo stato
                setFiles((prevFiles) => {
                    const newFiles = [...prevFiles, ...filesInfo];
                    newFiles.sort((a, b) => {
                        const dateA = new Date(a.fileName.split(".")[0]);
                        const dateB = new Date(b.fileName.split(".")[0]);
                        return dateB - dateA;
                    });

                    // Aggiorna `minDate` se necessario
                    const firstFileDate = new Date(newFiles[newFiles.length - 1].fileName.split(".")[0]);
                    setMinDate(firstFileDate);

                    return newFiles;
                });
            } catch (error) {
                console.error("Errore durante il caricamento dei file UUIDs:", error);
            }
        };

        fetchFiles(); // Esegui la funzione asincrona
    }, [basePath]);


    // Mappa rapida per date disponibili
    const availableDatesMap = new Map();
    files.forEach(file => {
        const dateStr = file.fileName.split(".")[0];
        availableDatesMap.set(dateStr, file.fileUUID);
    });

    const onDateClick = (date) => {
        const formatted = date.toLocaleDateString('sv-SE'); // formato YYYY-MM-DD
        const uuid = availableDatesMap.get(formatted);
        if (uuid) {
            navigate(`/logs/chat/${type}/${uuid}`);
        }
    };

    const tileClassName = ({ date, view }) => {
        const formatted = date.toLocaleDateString('sv-SE'); // formato YYYY-MM-DD

        // GIORNI
        if (view === 'month') {
            if (date > maxDate) return 'unavailableDate'; // blocca il futuro visivamente
            if (availableDatesMap.has(formatted)) return 'availableDate';
            return 'unavailableDate';
        }

        // MESI
        if (view === 'year') {
            if (date > maxDate) return 'unavailableDate';
            const month = date.toISOString().slice(0, 7); // es: "2025-04"
            const found = Array.from(availableDatesMap.keys()).some(k => k.startsWith(month));
            return found ? 'availableDate' : 'unavailableDate';
        }

        // ANNI
        if (view === 'decade') {
            if (date > maxDate) return 'unavailableDate';
            const year = date.getFullYear().toString();
            const found = Array.from(availableDatesMap.keys()).some(k => k.startsWith(year));
            return found ? 'availableDate' : 'unavailableDate';
        }

        return null;
    };

    return (
        <>
            <div className={"page__body"}>
                <Header/>
                <div className={"page__content"}>
                    <div className={"chats-CenterBox"}>
                        {type === "private" ? <CustomButton onClick={() => window.location.href = "/logs/chats/public"}>
                            Passa ai Log Pubblici
                        </CustomButton>
                        :
                            <CustomButton onClick={() => window.location.href = "/logs/chats/private"}>
                                Passa ai Log Privati
                            </CustomButton>
                        }

                    </div><br/>
                    <Calendar
                        onClickDay={onDateClick}
                        tileClassName={tileClassName}
                        minDate={minDate}
                        maxDate={maxDate}
                    />
                </div>
                <Footer/>
            </div>
        </>
    )
}

export default Chats;